import React, { useEffect, useRef } from "react";
import {
  GoogleMap,
  DirectionsRenderer,
  useJsApiLoader,
} from "@react-google-maps/api";

const MapMarker = ({ startAddress, endAddress, apiKey }) => {
  const libraries = ["places"];
  const mapContainerStyle = {
    width: "100%",
    height: "100%",
  };

  const mapOptions = {
    disableDefaultUI: true,
  };

  const directionsCallback = (response) => {
    if (response !== null && response.status === "OK") {
      setDirections(response);
    } else {
      console.error("Directions request failed");
    }
  };

  const mapRef = useRef(null);
  const [directions, setDirections] = React.useState(null);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: apiKey,
    libraries,
  });

  useEffect(() => {
    const fetchDirections = async () => {
      try {
        const startLocation = await getLatLngFromAddress(startAddress);
        const endLocation = await getLatLngFromAddress(endAddress);
        if (mapRef.current && isLoaded && window.google) {
          const directionsService = new window.google.maps.DirectionsService();
          const directionsServiceOptions = {
            origin: startLocation,
            destination: endLocation,
            travelMode: "DRIVING",
          };
          directionsService.route(directionsServiceOptions, directionsCallback);
        }
      } catch (error) {
        console.error(error.message);
      }
    };

    setTimeout(() => {
      fetchDirections();
    }, 1500);
  }, [startAddress, endAddress, isLoaded]);

  const getLatLngFromAddress = async (address) => {
    const geocoder = new window.google.maps.Geocoder();
    return new Promise((resolve, reject) => {
      geocoder.geocode({ address }, (results, status) => {
        if (status === "OK" && results.length > 0) {
          const location = results[0].geometry.location;
          resolve({ lat: location.lat(), lng: location.lng() });
        } else {
          reject(new Error(`Geocoding failed for address: ${address}`));
        }
      });
    });
  };

  return (
    <>
      {isLoaded && (
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={{ lat: 0, lng: 0 }}
          zoom={12}
          options={mapOptions}
          onLoad={(map) => (mapRef.current = map)}
        >
          {directions && <DirectionsRenderer directions={directions} />}
        </GoogleMap>
      )}
    </>
  );
};

export default MapMarker;
